<script setup>
import illustrationModeDeLivraison from "@/assets/images/illustration-mode-de-livraison.svg";
defineEmits(["openStoreLocator"]);
</script>
<script>
import LazyImage from "@/components/atoms/lazy-image";
import Titre from "@/components/atoms/titre";
import Button from "@/components/atoms/button";
import Badge from "@/components/atoms/badge";

export default {
  components: {
    LazyImage,
    Titre,
    Button,
    Badge
  }
};
</script>

<template>
  <div class="u-flex u-flex-column@sm u-flex-align-center">
    <LazyImage
      :src="illustrationModeDeLivraison"
      class="u-mr-lg u-mb-md@sm"
      width="320"
      height="190"
    />
    <div class="u-text-center@sm">
      <Titre
        tag="h2"
        variant="primary"
        class="u-mb-sm"
        size="xlg"
      >
        Vos courses où vous voulez !
      </Titre>
      <p class="u-mb-sm">
        Nous vous facilitons les courses en vous proposant plusieurs modes de livraison
      </p>

      <Badge
        outline="grey-5"
        radius="md"
        class="u-mr-xs u-py-xs u-px-md u-mb-sm"
      >
        Livraison
      </Badge>
      <Badge
        outline="grey-5"
        radius="md"
        class="u-mr-xs u-py-xs u-px-md u-mb-sm"
      >
        Drive
      </Badge>
      <Badge
        outline="grey-5"
        radius="md"
        class="u-mr-xs u-py-xs u-px-md u-mb-sm"
      >
        Click & collect
      </Badge>
      <Badge
        outline="grey-5"
        radius="md"
        class="u-mr-xs u-py-xs u-px-md u-mb-sm"
      >
        Point Retrait
      </Badge>
      <Badge
        outline="grey-5"
        radius="md"
        class="u-mr-xs u-py-xs u-px-md u-mb-sm"
      >
        Drive piéton
      </Badge>
      <div class="u-text-center@sm">
        <Button
          radius="full"
          variant="primary"
          size="md"
          @click="$emit('openStoreLocator')"
        >
          Sélectionner mon magasin
        </Button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
